<template>
  <div class="container py-4">
    <loading-messages v-if="loading"></loading-messages>
    <div class="alert alert-success" v-if="success">
      {{ $t('successMessage') }}
    </div>
    <form @submit.prevent="submit" v-if="!loading">
      <div class="row no-gutters">
        <div class="col-12 px-2" v-if="authUser.password_set">
          <div class="myfield">
            <div class="alert alert-danger" v-if="errors['password']">
              {{ errors["password"] }}
            </div>
            <input
              type="password"
              id="password"
              v-model="currentPassword"
              :placeholder="$t('currentPassword')"
            />
            <label for="password">{{ $t("currentPassword") }}</label>
          </div>
        </div>
        <div class="col-12 px-2">
          <div class="myfield">
            <div class="alert alert-danger" v-if="errors['password']">
              {{ errors["password"] }}
            </div>
            <input
              type="password"
              id="new_password"
              v-model="newPassword"
              :placeholder="$t('newPassword')"
            />
            <label for="new_password">{{ $t("newPassword") }}</label>
          </div>
        </div>
        <div class="col-12 px-2">
          <div class="myfield">
            <div class="alert alert-danger" v-if="errors['repeat_password']">
              {{ errors["repeat_password"] }}
            </div>
            <input
              type="password"
              id="password_confirm"
              v-model="password_confirm"
              :placeholder="$t('password_confirm')"
            />
            <label for="password_confirm">{{ $t("password_confirm") }}</label>
          </div>
        </div>
        <div class="col-12 my-3">
          <button class="btn btn-block save-btn p-3" :disabled="loading">
            {{ $t("submit") }}
            <save-icon></save-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import SaveIcon from '@/components/Icons/Save'
import LoadingMessages from '@/components/Loadings/Message'
export default {
  components: {
    LoadingMessages,
    SaveIcon
  },
  metaInfo: {
    title: 'Security'
  },
  data () {
    return {
      errors: {},
      currentPassword: '',
      newPassword: '',
      password_confirm: '',
      loading: false,
      success: false
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user'
    })
  },
  mounted () {
    this.setHead({ url: '/', text: this.$t('change-password') })
    this.setNavVisible(false)
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setHead: 'head/set',
      resetHead: 'head/reset',
      setError: 'alert/setError',
      setNavVisible: 'app/setNavVisible',
      setPasswordSet: 'auth/setPasswordSet'
    }),
    async submit () {
      let url = '/api/profile/set-password'
      let params = {
        password: this.newPassword,
        repeat_password: this.password_confirm
      }
      if (this.authUser.password_set) {
        url = '/api/profile/change-password'
        params = {
          current_password: this.currentPassword,
          new_password: this.newPassword,
          repeat_new_password: this.password_confirm
        }
      }
      this.loading = true
      try {
        await this.axios.post(url, params)
        this.loading = false
        this.currentPassword = ''
        this.newPassword = ''
        this.password_confirm = ''
        this.success = true
      } catch (err) {
        this.setError(err)
        this.loading = false
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "submit": "შენახვა",
    "successMessage": "ახალი პაროლი წარმატებით შეინახა",
    "currentPassword": "არსებული პაროლი",
    "newPassword": "ახალი პაროლი",
    "password_confirm": "გაიმეორე პაროლი",
    "change-password": "პაროლის შეცვლა"
  }
}
</i18n>
